var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeApp && _vm.appURL)?_c('iframe',{ref:"iframe",staticClass:"plugin-wrapper",attrs:{"src":_vm.appURL,"width":_vm.activeApp.width || '100%',"height":_vm.activeApp.height || '100%',"id":_vm.activeApp.extensionId,"sandbox":_vm.sandbox},on:{"load":function($event){return _vm.connectApp()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }